import { FETCH_MERCHANDISE_TYPES, FETCH_MERCHANDISE_TYPES_SUCCESS, FETCH_MERCHANDISE_TYPES_FAILURE } from '../actions';

const initialState = {
  merchandisetypes: [],
  loading: true,
  err: null,
  haveData: false
};

export const reducer = (state = initialState, action) => {
  switch(action.type) {
    case FETCH_MERCHANDISE_TYPES:
      return {
        ...state,
        loading: true,
        err: null,
        haveData: false
      };
    case FETCH_MERCHANDISE_TYPES_SUCCESS:
      return {
        ...state,
        loading: false,   
        haveData: true,     
        merchandisetypes: action.data
      };
    case FETCH_MERCHANDISE_TYPES_FAILURE:
      return {
        ...state,
        loading: false,
        haveData: false,
        err: action.error,
        merchandisetypes: []
      };
    default:
      return state;
  }
}